module.exports = ({
    "CDMS707TT001": "ล็อกฐานข้อมูล",
    "CDMS707MSG004": "ไม่สามารถล็อค DB ได้เนื่องจากมี Query ที่เปิดอยู่หรือมีการตอบแล้ว",
    "CDMS707MSG005": "ไม่สามารถล็อคฐานข้อมูลได้ เนื่องจากมีผู้เข้าร่วมวิจัยกำลังอยู่ระหว่างการเริ่มต้นระบบ\nกรุณารอจนกว่าการเริ่มต้นจะเสร็จสมบูรณ์ แล้วลองอีกครั้ง",
    "CDMS402BTN001": "ส่งออกรายงาน",
    "CDMS402BTN002": "ล็อคฐานข้อมูล",
    "CDMS402BTN003": "ปลดล็อคฐานข้อมูล",
    "CDMS707TT002": "สถานะการล็อกฐานข้อมูล",
    "CDMS707TT003": "ประวัติการล็อกฐานข้อมูล",
    "CDMS707LB001": "รหัสการศึกษา",
    "CDMS707H001": "ชื่อการศึกษา",
    "CDMS707H002": "Status",
    "CDMS707H003": "เหตุผล",
    "CDMS707LB003": "สถานะ",
    "CDMS707LB004": "จำนวนผู้เข้าร่วมวิจัย",
    "CDMS707LB005": "จำนวนผู้ลงนามอิเล็กทรอนิกส์",
    "CDMS707LB006": "จำนวนหน้าของ CRF",
    "CDMS707LB007": "จำนวนหน้าของ CRF ที่ถูกบันทึก",
    "CDMS707LB008": "Open query ทั้งหมด",
    "CDMS707LB009": "จำนวน Query ที่ตอบแล้ว",
    "CDMS707H004": "ลายเซ็นอิเล็กทรอนิกส์",
    "CDMS707H005": "วันที่ลงนาม",
    "CDMS707MSG001": "โปรดระบุุเหตุผล",
    "CDMS707P001": "กรุณากรอกเหตุผล",
    "CDMS707LB010": "เหตุผล",
    "CDMS706LB001": "* สำหรับการป้อนรหัสผ่านนี้ ข้าพเจ้ารับรองว่าข้อมูลทั้งหมดในแบบฟอร์มที่เลือกนั้นเป็นไปตามข้อกำหนดและกฎระเบียบที่บังคับใช้",
    "CDMS700MSG003": "รหัสผู้ใช้งานหรือรหัสผ่านที่คุณป้อนไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง"
});
